export default "__VITE_ASSET__Btt$WdmZ__"